import { useEffect, useState } from 'react';

/*
  If there's a viewport tag and it has 'maximum-scale=1', dont do anything
  If theres a viewport tag and it doesn't have 'maximum-scale=1', add it
  If theres no viewport tag, add one with 'maximum-scale=1'

  On unmount, undo the above changes
*/

const useStopZoomOnInputs = () => {
  const [originalValue, setOriginalValue] = useState<string>(null);
  const [metaTag, setMetaTag] = useState<HTMLMetaElement>(null);

  const setViewportTag = () => {
    if (originalValue || metaTag) {
      return;
    }

    const viewport = document.querySelector(
      'meta[name=viewport]'
    ) as HTMLMetaElement;

    if (viewport) {
      setOriginalValue(viewport.content);

      if (!viewport.content.includes('maximum-scale=1')) {
        viewport.content = `${viewport.content}, maximum-scale=1`;
      }

      if (!viewport.content.includes('minimum-scale=1')) {
        viewport.content = `${viewport.content}, minimum-scale=1`;
      }
    } else {
      const newMetaTag = document.createElement('meta');
      newMetaTag.name = 'viewport';
      newMetaTag.content = 'maximum-scale=1, minimum-scale=1';
      setMetaTag(newMetaTag);
      document.head.appendChild(newMetaTag);
    }
  };

  const unsetViewportTag = () => {
    if (originalValue) {
      const viewport = document.querySelector(
        'meta[name=viewport]'
      ) as HTMLMetaElement;

      viewport.content = originalValue;
    } else if (metaTag) {
      metaTag.remove();
    }
  };

  useEffect(() => {
    setViewportTag();

    return unsetViewportTag;
  }, [originalValue, metaTag]);

  return null;
};

export default useStopZoomOnInputs;
